import React from 'react';

import { loadFont } from 'graphics';
import GameContext from 'gamectx';

function RenderedTooltip({ text }) {
  const ref = React.useRef();

  const lineHeight = 16;
  React.useEffect(() => {
    loadFont('font16').then(font => {
      if (!ref.current) return; // already dismounted

      const processed = text.map(line => line.replace(/\u2013/g, '-'));

      const widths = processed.map(str => font.measure(str));
      const boxWidth = Math.max(...widths) + 8;
      const boxHeight = lineHeight * processed.length;
      ref.current.width = boxWidth;
      ref.current.height = boxHeight;

      const ctx = ref.current.getContext("2d");
      ctx.fillStyle = 'rgba(8, 8, 8, .95)';
      ctx.fillRect(0, 0, boxWidth, boxHeight);

      for (let i = 0; i < processed.length; ++i) {
        font.render(ctx, (boxWidth - widths[i]) >> 1, i * lineHeight + 8, processed[i]);
      }
    });
  }, [text]);

  return <canvas className="d2p-RenderedTooltip" width={64} height={lineHeight * text.length} ref={ref}/>;
}

function FontTooltip({ text }) {
  return (
    <div className="d2p-GameTooltip">
      {text.map((line, index) => {
        if (!line) return '\u00a0';
        const parts = line.split(/(?:\\xff|\xff)c([\d:;<])/);
        const result = [];
        for (let i = 0; i < parts.length; i += 2) {
          if (!parts[i]) continue;
          if (i) {
            result.push(<span key={i} className={`d2-color-${parts[i - 1].charCodeAt(0) - 0x30}`}>{parts[i]}</span>);
          } else {
            result.push(parts[i]);
          }
        }
        return <div key={index}>{result}</div>;
      })}
    </div>
  );
}

export default function GameTooltip({ text }) {
  const hd = React.useContext(GameContext).gfx.hd;
  return hd ? <FontTooltip text={text}/> : <RenderedTooltip text={text}/>;
}
